import ApiRequest from '../api/request';

type Params = { route: 'classy'; action: any; params?: any };

class Airtable {
  static async Interact(params: Params, apiToken: string) {
    try {
      if (params.action === 'schema') {
        return Airtable.Schema(params, apiToken);
      }
      if (params.action === 'bases') {
        return Airtable.Bases(params, apiToken);
      }
    } catch (err: any) {
      return { error: err.message };
    }
  }

  static async Schema(params: Params, apiToken: string) {
    try {
      const response = await ApiRequest.sendRequest({
        method: 'post',
        params: params.params,
        path: `airtable/${params.action}`,
        token: apiToken,
      });
      return response.data;
    } catch (err: any) {
      return { error: err.message };
    }
  }

  static async Bases(params: Params, apiToken: string) {
    try {
      const response = await ApiRequest.sendRequest({
        method: 'post',
        params: params.params,
        path: `airtable/${params.action}`,
        token: apiToken,
      });
      return response.data;
    } catch (err: any) {
      return { error: err.message };
    }
  }
}

export default Airtable;
